import useCookie from 'hooks/useCookie';
import React, {PropsWithChildren, useEffect, useState} from 'react';
import scrollIntoView from 'scroll-into-view';

import Notifications from '@skippay/core/components/Notifications';
import useLocation from '@skippay/core/hooks/useLocation';
import {be, bm} from '@skippay/core/utils/classUtils';

import Footer from './components/Footer';
import HeaderOffset from './components/HeaderOffset';
import PublicHeader from './components/PublicHeader';

import './index.sass';

const MODULE_NAME = 'PublicLayout';

interface Props {
	headerBottomSection?: JSX.Element;
}

const DEFAULT_HEADER_MOBILE_HEIGHT = 60;
const DEFAULT_OFFSET = 16;

function PublicLayout(props: PropsWithChildren<Props>): JSX.Element {
	const {headerBottomSection, children} = props;
	const [offset, setOffset] = useState<number>(DEFAULT_HEADER_MOBILE_HEIGHT);
	useCookie();

	const {location: {hash}} = useLocation();

	useEffect(() => {
		let timeoutId: null | ReturnType<typeof setTimeout> = null;
		if (hash) {
			timeoutId = setTimeout(() => {
				const element = document.getElementById(hash);
				if (element) {
					scrollIntoView(element, {time: 1000, align: {top: 0, topOffset: offset + DEFAULT_OFFSET}});
				}
			}, 0)
		}

		return () => {
			if(timeoutId) {
				clearTimeout(timeoutId);
			}
		}
	}, [hash, offset]);

	return (
		<div>
			<div className={bm(MODULE_NAME)} style={{paddingTop: offset}}>
				<HeaderOffset onOffsetChange={setOffset}>
					<PublicHeader headerBottomSection={headerBottomSection}/>
				</HeaderOffset>

				<div className={be(MODULE_NAME, 'notifications')}>
					<Notifications/>
				</div>

				<div className={be(MODULE_NAME, 'contentWrapper')}>
					<div className={be(MODULE_NAME, 'content')}>{children}</div>
				</div>

				<div className={be(MODULE_NAME, 'footer')}>
					<Footer/>
				</div>
			</div>
		</div>
	);
}

export default PublicLayout;
